import { useEffect, useRef } from "react";
import api from "@/api/api.js";
import i18n from "@/i18n.js";
import $ from "jquery";
import "datatables.net";
import languageES from "datatables.net-plugins/i18n/es-MX";
import { formatDate } from "@/utils/formatDate";

const ContactsAdmin = () => {
  const tableRef = useRef(null);
  const dataTable = useRef(null);

  useEffect(() => {
    if (!tableRef.current) return;
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().destroy();
    }

    dataTable.current = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      language: languageES,
      order: [[0, "asc"]],
      ajax: async (dtParams, callback) => {
        try {
          const response = await api.get("/contacts", {
            params: {
              page: dtParams.start / dtParams.length + 1,
              itemsPerPage: dtParams.length,
              search: dtParams.search?.value || undefined,
            },
          });
          callback({
            data: response.data["hydra:member"],
            recordsTotal: response.data["hydra:totalItems"],
            recordsFiltered: response.data["hydra:totalItems"],
          });
        } catch (error) {
          console.error("Error al cargar contactos:", error);
          callback({ data: [] });
        }
      },
      columns: [
        { title: "Razón social / Nombre", data: "businessName" },
        { title: "RFC", data: "taxIdentification" },
        { title: "Tipo de persona", data: "type" },
        { title: "Correo", data: "emailContact" },
        {
          title: "Vigencia del certificado",
          render: (data, type, row) =>
            row["certificateTaxValidDate"]
              ? formatDate(row["certificateTaxValidDate"], false)
              : "Sin certificado",
        },
        { title: "Código postal", data: "postalCode" },
        {
          title: "Dueño (usuario)",
          render: (data, type, row) => {
            const u = row?.user;
            if (!u) return "—";
            const uid = u["@id"]?.split("/").pop();
            const label = u.username ?? "—";
            return uid
              ? `<a href="/client-users/${uid}/show">${label}</a>`
              : label;
          },
        },
      ],
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, []);

  return (
    <div className="col">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title pb-3">{i18n.t("page.receiverList")}</h5>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="display"
              style={{ width: "100%" }}
            ></table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsAdmin;
